import {
    askApi,
    depUrl,
    compEditUrl,
    compSetUrl,
    compDeselectUrl,
    plansUrl,
    changePlanUrl,
    depAccessUrl,
    depAcceptUrl,
    completeOnboardingUrl,
    ActivateAddonUrl,
    employUrl,
    apiDomainEmploy,
} from '../endpoints';
import { getCache } from '@/helpers';
import { DepartmentType } from '@enums/DepartmentType';

export function updateDepartment(payload) {
    const cache = getCache();
    const currentDepartment = cache?.currentDepartment;

    if (!currentDepartment) {
        return Promise.reject('Invalid department');
    }

    const endpoint = currentDepartment.type === DepartmentType.Employ ? `${employUrl}/settings` : depUrl;

    return new Promise((resolve) => {
        askApi
            .post(endpoint, payload, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
            });
    });
}

export function getSelectedCompenteces() {
    return new Promise((resolve) => {
        askApi.get(compEditUrl).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function completeOnboarding(payload) {
    return new Promise((resolve) => {
        askApi.post(completeOnboardingUrl, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function completeOnboardingBanner(payload) {
    return new Promise((resolve) => {
        askApi.post(`${apiDomainEmploy}/departments/onboarding/complete`, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function setSelectedCompenteces(payload) {
    return new Promise((resolve) => {
        askApi.put(compSetUrl, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function deselectedCompenteces(payload) {
    return new Promise((resolve) => {
        askApi.put(compDeselectUrl, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function getPlans() {
    return new Promise((resolve) => {
        askApi.get(plansUrl).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function changePlan(payload) {
    return new Promise((resolve) => {
        askApi.post(`${changePlanUrl}/${payload.id}`, payload).then((response) => {
            if (response.status === 200 || response.status === 201 || response.status === 202) {
                resolve(response.data);
            }
        });
    });
}

export function toggleAddon(payload) {
    if (payload.method === 'revoke') {
        return new Promise((resolve) => {
            askApi.delete(`${ActivateAddonUrl}/${payload.id}`).then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
            });
        });
    } else {
        return new Promise((resolve) => {
            askApi.post(`${ActivateAddonUrl}/${payload.id}`, payload).then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
            });
        });
    }
}

export function updateAddonMeta(payload) {
    return new Promise((resolve) => {
        askApi.put(`${ActivateAddonUrl}/${payload.id}/meta`, payload).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}

export function grantAccess(payload) {
    const cache = getCache();
    const currentDepartment = cache?.currentDepartment;

    const url = currentDepartment?.type === 'employ' ? apiDomainEmploy + '/departments/access' : depAccessUrl;

    if (payload.method === 'revoke') {
        return new Promise((resolve) => {
            askApi.delete(url, { data: payload }).then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
            });
        });
    }

    if (payload.method === 'accept') {
        return new Promise((resolve) => {
            askApi.post(depAcceptUrl, payload).then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
            });
        });
    } else {
        return new Promise((resolve) => {
            askApi.post(url, payload).then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
            });
        });
    }
}
